/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ActualPhase, Ticket } from '@touchplan/common';
import { Rectangle } from 'pixi.js-legacy';

interface selectable {
	selected: boolean;
}

class AbstractSelection<Model extends selectable> {
	public list: Map<string, Model> = new Map();
	public combinedRect = new Rectangle();

	public add(key: string, thing: Model) {
		this.list.set(key, thing);
		this.addRectangle(thing);
	}
	// tryAdd(key: string, thing: Model){
	// 	if(thing.selected && !this.list.has(key)){
	// 		this.add(key, thing);
	// 		return true;
	// 	}
	// 	return false;
	// }
	public remove(key: string) {
		this.list.delete(key);
		this.recalcRectangle();
	}
	// tryRemove(key:string){
	// 	if(this.list.has(key) && !this.list.get(key).selected){
	//
	// 	}
	// }
	public addRectangle(thing: Model) {}
	public recalcRectangle() {}
}

export class TicketSelection extends AbstractSelection<Ticket> {
	public statistics = {
		completed: new Map<string, Ticket>(),
		pinned: new Map<string, Ticket>(),
		started: new Map<string, Ticket>(),
	};

	public updateStats(changedTicket: Ticket) {
		if (this.list.has(changedTicket.$id)) {
			//completed check
			if (changedTicket.view.isActualized && !this.statistics.completed.has(changedTicket.$id)) {
				this.statistics.completed.set(changedTicket.$id, changedTicket);
			} else if (!changedTicket.view.isActualized && this.statistics.completed.has(changedTicket.$id)) {
				this.statistics.completed.delete(changedTicket.$id);
			}

			// started tickets check
			if (
				changedTicket.view.actualPhase === ActualPhase.started &&
				!this.statistics.started.has(changedTicket.$id)
			) {
				this.statistics.started.set(changedTicket.$id, changedTicket);
			} else if (
				!(changedTicket.view.actualPhase === ActualPhase.started) &&
				this.statistics.started.has(changedTicket.$id)
			) {
				this.statistics.started.delete(changedTicket.$id);
			}

			//pinned check
			// if(changedTicket.view.liveLastPromise && !this.statistics.pinned.has(changedTicket.$id)){
			// 	this.statistics.pinned.set(changedTicket.$id, changedTicket);
			// }
			// else if(!changedTicket.view.isActualized && this.statistics.pinned.has(changedTicket.$id)){
			// 	this.statistics.pinned.delete(changedTicket.$id);
			// }
		} else {
			this.statistics.completed.delete(changedTicket.$id);
			this.statistics.pinned.delete(changedTicket.$id);
			this.statistics.started.delete(changedTicket.$id);
		}
	}

	public addRectangle(ticket: Ticket) {
		let v = ticket.view;
		let rect = new Rectangle(v.left, v.top, v.width, v.height);
		if (this.list.size === 1) {
			this.combinedRect = rect;
		} else {
			this.combinedRect.enlarge(rect);
		}
	}
	//TODO - replace with a fancy cache
	public recalcRectangle() {
		let values = this.list.values();

		let first = this.list.values().next();
		if (first.done) {
			this.combinedRect = new Rectangle();
			return;
		}

		let v = first.value.view;
		this.combinedRect = new Rectangle(v.left, v.top, v.width, v.height);

		let next = values.next();
		while (!next.done) {
			let v = next.value.view;
			let rect = new Rectangle(v.left, v.top, v.width, v.height);
			this.combinedRect.enlarge(rect);

			next = values.next();
		}
	}
}
